/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import formatCurrency from 'shared/utils/formatCurrency';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { TableCosting } from 'shared/components';

type ServiceTableProps = {
  haierCostData: any;
};

const ServiceTable: React.FC<ServiceTableProps> = ({ haierCostData }) => {
  const { costingItem } = haierCostData;
  const columnsTableService = [
    {
      title: '',
      children: [
        {
          title: 'รายการ',
          dataIndex: 'itemName',
          key: 'itemName',
          width: 200,
        },
        {
          title: 'จำนวน',
          dataIndex: 'qty',
          key: 'qty',
          width: 50,
          align: 'right',
        },
      ],
    },
    {
      title: 'รายการต้นทุน',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#FDDF7C',
        margin: '-6px',
      },
      children: [
        {
          title: 'ราคาต่อหน่วย',
          dataIndex: 'costPrice',
          key: 'costPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ส่วนลด',
          dataIndex: 'discountCostPrice',
          key: 'discountCostPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาหลังลด',
          dataIndex: 'amountCostPrice',
          key: 'amountCostPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ภาษีมูลค่าเพิ่ม',
          dataIndex: 'vatCostPrice',
          key: 'vatCostPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'หัก ณ ที่จ่าย',
          dataIndex: 'whtCostPrice',
          key: 'whtCostPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาต้นทุน',
          dataIndex: 'totalCostPrice',
          key: 'totalCostPrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
      ],
    },
    {
      title: 'รายการรายได้',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#74B662',
        margin: '-6px',
      },
      children: [
        {
          title: 'ราคาต่อหน่วย',
          dataIndex: 'revenuePrice',
          key: 'revenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ส่วนลด',
          dataIndex: 'discountRevenuePrice',
          key: 'discountRevenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาหลังลด',
          dataIndex: 'amountRevenuePrice',
          key: 'amountRevenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ภาษีมูลค่าเพิ่ม',
          dataIndex: 'vatRevenuePrice',
          key: 'vatRevenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'หัก ณ ที่จ่าย',
          dataIndex: 'whtRevenuePrice',
          key: 'whtRevenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาขาย',
          dataIndex: 'totalRevenuePrice',
          key: 'totalRevenuePrice',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
      ],
    },
  ];

  const serviceGroup = _.chain(costingItem)
    .groupBy('service_category_name')
    .map((value, key) => ({
      serviceCategoryName: key,
      data: value,
    }))
    .value();

  const dataTableService = serviceGroup.reduce<any[]>((total, currentGroup) => {
    const rowService = currentGroup.data.map((item) => ({
      key: uuidv4(),
      itemName: item.itemName,
      qty: item.qty,
      costPrice: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.price.cost), '-')}
        </div>
      ),
      discountCostPrice: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.discount.cost), '-')}
        </div>
      ),
      amountCostPrice: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.totalPrice.cost), '-')}
        </div>
      ),
      vatCostPrice: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.vat.cost), '-')}
        </div>
      ),
      whtCostPrice: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.wht.cost), '-')}
        </div>
      ),
      totalCostPrice: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.grandTotalPrice.cost), '-')}
        </div>
      ),
      revenuePrice: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.price.sale), '-')}
        </div>
      ),
      discountRevenuePrice: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.discount.sale), '-')}
        </div>
      ),
      amountRevenuePrice: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.totalPrice.sale), '-')}
        </div>
      ),
      vatRevenuePrice: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.vat.sale), '-')}
        </div>
      ),
      whtRevenuePrice: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.wht.sale), '-')}
        </div>
      ),
      totalRevenuePrice: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(item.grandTotalPrice.sale), '-')}
        </div>
      ),
    }));

    return [...total, ...rowService];
  }, []);

  return (
    <TableCosting
      bordered
      className="table-1"
      pagination={false}
      columns={columnsTableService}
      dataSource={dataTableService}
    />
  );
};

export default ServiceTable;
